import { useState } from "react";
import ChevronDirectionEnum from "@models/ChevronDirectionEnum";
import ICatalog_Item from "@models/ICatalog_Item";
import IOrder from "@models/IOrder";
import ISupplierModel from "@models/ISupplierModel";
import OrderEntryService from "@services/OrderEntryService";
import ChevronToggle from "@components/shared/ChevronToggle/ChevronToggle";
import OwButton from "@components/shared/OwButton/OwButton";
import "./CatalogViewerCart.scss";
import { IAddBulkItems } from "@models/IAddBulkItems";
import { CatalogViewerCartItem } from "../CatalogViewerCartItem/CatalogViewerCartItem";
import IUserUI from "@models/IUserUI";

type Props = {
    order: IOrder;
    items: IAddBulkItems[];
    removeCartItem: (item: ICatalog_Item, index: number) => void;
    addCartToOrder: () => void;
    supplierModel: ISupplierModel;
    userModel: IUserUI;
};

const CatalogViewerCart = (props: Props) => {
    const [isOpen, setIsOpen] = useState(false);
    const [showQtyOnHand, setShowQtyOnHand] = useState<{ [key: string]: boolean }>({});
    const [existingQtyOnHand, setExistingQtyOnHand] = useState<{ [key: string]: number }>({});

    const toggleOpen = () => {
        setIsOpen(!isOpen);
    };

    const getToOrderQty = (item: ICatalog_Item, value: number): number => {
        let existingOrderQtyOnHand = 0;

        if (props.order.Order_Items) {
            for (const orderItem of props.order.Order_Items) {
                if (orderItem.Catalog_Item?.guid === item.guid) {
                    existingOrderQtyOnHand += Number(orderItem.qty);
                }
            }
        }

        const toOrderTotal = Number(value) + existingOrderQtyOnHand;

        return toOrderTotal;
    };

    const validateMinOrderQty = (item: ICatalog_Item, value: number): boolean => {
        let isQtyValid = true;

        const toOrderTotal = getToOrderQty(item, value);

        if (item.min_order_qty) {
            if (toOrderTotal >= item.min_order_qty) {
                isQtyValid = true;
            } else {
                isQtyValid = false;
            }
        }

        return isQtyValid;
    };

    const validateInventoryForItem = (item: ICatalog_Item, value: number): boolean => {
        let qty_on_hand = 0;
        let hasInventory = false;
        let allowBackorder = false;

        if (item) {
            qty_on_hand = item.qty_on_hand || 0;
            hasInventory = item.has_inventory || false;
            allowBackorder = item.allow_backorder || false;
        }

        const _showQtyOnHand = { ...showQtyOnHand };
        const _existingQtyOnHand = { ...existingQtyOnHand };

        let isQtyValid = false;

        const toOrderTotal = getToOrderQty(item, value);

        if (item.min_order_qty) {
            if (toOrderTotal >= item.min_order_qty) {
                isQtyValid = true;
            } else {
                isQtyValid = false;
            }
        }

        if (hasInventory) {
            if (toOrderTotal > qty_on_hand) {
                if (allowBackorder) {
                    isQtyValid = true;
                } else {
                    _showQtyOnHand[item.guid] = true;

                    setShowQtyOnHand(_showQtyOnHand);
                    setExistingQtyOnHand(_existingQtyOnHand);

                    return isQtyValid;
                }
            }
        }

        if (hasInventory && (!allowBackorder || toOrderTotal <= qty_on_hand)) {
            _showQtyOnHand[item.guid] = false;
            isQtyValid = true;

            setShowQtyOnHand(_showQtyOnHand);
            setExistingQtyOnHand(_existingQtyOnHand);
        }

        return isQtyValid;
    };

    let isOpenClass = "h-3r";

    if (isOpen) {
        isOpenClass = "h-20r";
    }

    let step = 1;

    switch (props.supplierModel.qty_precision) {
        case 1:
            step = 0.1;
            break;

        case 2:
            step = 0.01;
            break;

        case 3:
            step = 0.001;
            break;

        default:
            step = 1;
            break;
    }

    let allItemsValid = true;

    for (const details of props.items) {
        const qty = details.item.qty;

        console.log("cart item qty: ", qty);

        // let isQtyValid = item.has_inventory ? this.validateInventoryForItem(item, qty) : this.validateMinOrderQty(item, qty);
        const { enableAdd } = OrderEntryService.doInventoryValidation(
            details.item.Catalog_Item,
            qty,
            props.order.Order_Items,
            props.supplierModel,
            props.order,
            0
        );

        if (!enableAdd) {
            allItemsValid = false;
        }
    }

    // console.log("CatalogViewerCart", this.props.items);
    // console.log("CatalogViewerCart State Items", this.state.items);

    return (
        <div className={"CatalogViewerCart w-100 " + isOpenClass} style={{ bottom: 0, left: 0 }}>
            <div className={"d-flex flex-row w-100 p-2 justify-content-between"}>
                <div className={"d-flex justify-content-start "}>
                    <span className={"me-2"}>
                        <i className={"fad fa-shopping-cart"}></i>
                    </span>
                    <span>
                        <span className={"badge text-bg-warning"}>{props.items.length || 0}</span>
                    </span>
                    <span>
                        <OwButton
                            title={"add_to_order"}
                            fn={props.addCartToOrder}
                            className={"ms-4 btn-primary"}
                            disabled={!props.items.length || !allItemsValid}
                        />
                    </span>
                </div>
                <div className={"d-flex align-items-center justify-content-end"}>
                    <ChevronToggle
                        className={""}
                        toggleFn={toggleOpen}
                        isVisible={isOpen || false}
                        direction={ChevronDirectionEnum.UP}
                        showChevron={true}
                    />
                </div>
            </div>
            <div className={"contents h-16r " + (isOpen ? "" : "d-none")}>
                {props.items.map((item, index: number) => {
                    return (
                        <CatalogViewerCartItem
                            key={index}
                            itemDetail={item}
                            removeCartItem={props.removeCartItem}
                            order={props.order}
                            supplierModel={props.supplierModel}
                            userModel={props.userModel}
                            index={index}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default CatalogViewerCart;
